import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Bar,
  BarChart,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import { styles } from "./styles";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { classes, countReaction } = this.props;

    return (
      <ResponsiveContainer width={"100%"} height={400}>
        <BarChart
          data={countReaction}
          margin={{ top: 24, right: 8, left: 8, bottom: 24 }}
          className={classes.reCharts}
        >
          {/* <CartesianGrid strokeDasharray="3 3"/> */}
          <XAxis
            className={classes.xAxis}
            dy={10}
            dataKey="name"
            axisLine={true}
            tickLine={false}
            style={{
              fill: "#494e63",
              fontSize: 16,
              fontWeight: 500,
              fontFamily: "Roboto",
            }}
          />
          <YAxis allowDecimals={false} hide />
          {/* <Tooltip/> */}
          {/* <Legend/> */}
          <Bar dataKey="Like" fill="#ffbc5b">
            <LabelList dataKey="Like" position="top" offset={8} />
          </Bar>
          <Bar dataKey="Heart" fill="#ae76ff">
            <LabelList dataKey="Heart" position="top" offset={8} />
          </Bar>
          <Bar dataKey="Follow" fill="#ff6b5c">
            <LabelList dataKey="Follow" position="top" offset={8} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(styles, { withTheme: true })(Dashboard))
);
